import {
  Form,
  Input,
  Table,
  Button,
  Select,
  Tag,
  Card,
  message,
  Row,
  Col,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
// import publicColumn from "../subjectStudy/components/publicColumn";
import "./index.scss";
import Request from "@/networkReq/request";
import Http from "@/networkReq/http";
import { useHistory } from "react-router-dom";
const FormItem = Form.Item;
const { Option } = Select;
const { Search } = Input;

export default function ApplyTrainingRecords() {
  const [form] = Form.useForm();
  const [datasource, setDatasource] = useState([]);
  const history = useHistory();
  const [page, setPage] = useState(1); //当前页
  const [total, setTotal] = useState(0);
  const [time,setTime] = useState(0); //time只作为依赖使用 改变time  使useEffect中的代码重新执行
  const [value,setValue]=useState("");
  const handleSubjectDetail = (row) => {
    const { courseId } = row;
    history.push(`/entrance/personal/applyTrainingRecords/detail/${courseId}`);
  };

  useEffect(() => {
    const searchValue = form.getFieldsValue();
    console.log("timetimetimetimetimetime",time);
    console.log("valuevaluevaluevaluevaluevaluevalue",value);
    const params = {
      status:value,
      current: page,
      size: 10,
    };
    for (const key in searchValue) {
      if (searchValue[key] && key !== "applyStatus") {
        params[key] = searchValue[key];
      }
    }

    Http.get(Request.applyForRecord(), { descs:'update_time',...params }, (obj) => {
      if (obj.code == 200) {
        const {
          data: { records = [], total = 0 },
        } = obj;
        setDatasource(records);
        setTotal(total);
      } else {
        setDatasource([]);
        setTotal(0);
        message.error(obj.msg || obj.message || "请求失败，请重试");
      }
    });
  }, [page, time]);

  const extraColumn = [
    {
      title: "课程名称",
      dataIndex: "courseName",
      align:'center'
    },
    {
      title: "培训行业",
      dataIndex: "courseType",
    },
  ];
  const publicColumn =[{
    title: "序号",
    dataIndex: "index",
    align:'center',
    render(text, record, index) {
        return index + 1;
    },
},
{
    title: "机构名称",
    dataIndex: "unitName",
    align:'center',

},
{
    title: "课程名称",
    dataIndex: "courseName",
    align:'center',

},
{
    title: "主讲老师",
    align:'center',
    dataIndex: "jsName",
},
// {
//     title: "授课形式",
//     dataIndex: "teachType",
//     align:'center',
//     render(text, record, index) {
//         return `线下`
//     },
// },
];
  const extraColumnOperate = [
    {
      title: "审核结果",
      dataIndex: "applyResult",
      fixed:'right',
      render(text, record) {
        const { status } = record;
        switch (status) {
          case 0:
            return (
              <Tag
                color="#3356C5"
                className="apply_train_records_tag tag_loading"
              >
                审核中
              </Tag>
            );
          case 1:
            return (
              <Tag color="#0FC73E" className="apply_train_records_tag tag_pass">
                审核通过
              </Tag>
            );
          case 2:
            return (
              <Tag color="#DD0B0B" className="apply_train_records_tag tag_fail">
                审核未通过
              </Tag>
            );
          default:
            return <></>;
        }
      },
    },
    {
      title: "操作",
      dataIndex: "operate",
      fixed:'right',
      render(text, record, index) {
        return (
          <>
            <Button
              type="link"
              onClick={() => {
                handleSubjectDetail(record);
              }}
            >
              查看
            </Button>
          </>
        );
      },
    },
  ];

  const column = [].concat(publicColumn).concat(extraColumnOperate);
  column.splice(2, 0, ...extraColumn);
  console.log('columncolumncolumncolumn',column);
  
  return (
    <Card style={{ marginLeft: 16 }}>
      <div style={{ marginBottom: 16 }}>
        <Form
          layout="inline"
          form={form}
          initialValues={{ applyStatus: "" }}
        >
          <Row justify="space-between" wrap={false}>
            <Col>
              <FormItem label="机构名称" name="unitName">
                <Search
                  style={{ width: 240, height: 32 }}
                  onSearch={() => setTime(new Date().valueOf())}
                />
              </FormItem>
            </Col>
            <Col>
              <FormItem label="课程名称" name="courseName">
                <Search
                  style={{ width: 240, height: 32 }}
                  onSearch={() => setTime(new Date().valueOf())}
                />
              </FormItem>
            </Col>
            <Col>
              <FormItem label="审核结果" name="applyStatus">
                <Select
                  style={{ width: 248, height: 32 }}
                  onChange={(value) => setTime(new Date().valueOf(),setValue(value))}
                >
                  <Option value="">全部</Option>
                  <Option value="0">审核中</Option>
                  <Option value="1">审核通过</Option>
                  <Option value="2">审核未通过</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <Table
        dataSource={datasource}
        columns={column}
        bordered
        pagination={{
          total,
          showQuickJumper: {
            goButton: <Button className={"pagination_jump"}>确定</Button>,
          },
          showTotal: (total) => `共 ${total} 条`,
          onChange: (page, pageSize) => setPage(page),
          showSizeChanger: false,
          current: page,
        }}
      />
    </Card>
  );
}
